import { useCallback, useEffect, useState } from 'react';
import { apiFetch } from '@/client/lib/api';
import type { GcsFileInfo } from '@/client/app/hooks/useAccountFiles';

export const FILES_API_BASE = '/api/files';

export function useFiles() {
  const [files, setFiles] = useState<GcsFileInfo[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    apiFetch<{ files: GcsFileInfo[] }>(FILES_API_BASE)
      .then((res) => setFiles(res.files))
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, []);

  const removeFile = useCallback((path: string) => {
    setFiles((prev) => prev.filter((f) => f.path !== path));
  }, []);

  return { files, loading, error, removeFile };
}
